module.exports = __webpack_public_path__ + "static/the-shadow-of-the-wind-27ab761c32557c1f137d7f17fe6dab58.jpg";